function GridIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='currentColor'
      >
        <g clipPath='url(#clip0_7858_95704)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.6312 3.18326C10.8355 2.92748 9.0056 3.26471 7.41732 4.14412C5.82904 5.02353 4.56841 6.39747 3.82542 8.05892C3.08242 9.72036 2.8973 11.5793 3.29795 13.3556C3.6986 15.1318 4.66332 16.7293 6.04673 17.9071C7.43014 19.0849 9.1573 19.7793 10.9679 19.8857C12.7786 19.992 14.5746 19.5046 16.0853 18.4968C17.596 17.489 18.7397 16.0154 19.3439 14.2982C19.5362 13.7514 20.1336 13.4648 20.6781 13.6579C21.2226 13.8511 21.5081 14.4509 21.3157 14.9977C20.5605 17.1443 19.1309 18.9862 17.2425 20.246C15.3541 21.5057 13.1091 22.115 10.8458 21.9821C8.58251 21.8491 6.42356 20.9811 4.6943 19.5088C2.96503 18.0366 1.75914 16.0398 1.25832 13.8195C0.757504 11.5991 0.988905 9.27545 1.91765 7.19865C2.8464 5.12184 4.42218 3.40441 6.40753 2.30515C8.39288 1.20589 10.6802 0.784355 12.9249 1.10407C15.1643 1.42302 17.2401 2.46245 18.8411 4.0662L23.6712 8.63354C24.0916 9.0311 23.3959 9.07782 23 9.5C22.6041 9.92218 21.9204 9.89756 21.5 9.5L17.3962 5.58438C17.3885 5.5771 17.3809 5.5697 17.3734 5.56219C16.0913 4.27395 14.427 3.43903 12.6312 3.18326Z'
            fill='#E5E5EA'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.39611 8.09466C9.63997 7.95545 9.93588 7.9707 10.166 8.13436L14.666 11.3344C14.8747 11.4827 15 11.7325 15 12C15 12.2675 14.8747 12.5173 14.666 12.6656L10.166 15.8656C9.93588 16.0293 9.63997 16.0446 9.39611 15.9053C9.15224 15.7661 9 15.495 9 15.2V8.8C9 8.50496 9.15224 8.23388 9.39611 8.09466Z'
            fill='#E5E5EA'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M22.3896 4.0062C22.9385 3.94521 23.4329 4.34075 23.4939 4.88966L23.9939 9.38966C24.0253 9.67236 23.9348 9.95506 23.7451 10.167C23.5554 10.379 23.2844 10.5001 23 10.5001H19C18.4477 10.5001 18 10.0524 18 9.50009C18 8.9478 18.4477 8.50009 19 8.50009H21.8827L21.5061 5.11052C21.4451 4.56161 21.8407 4.06719 22.3896 4.0062Z'
            fill='#E5E5EA'
          />
        </g>
        <defs>
          <clipPath id='clip0_7858_95704'>
            <rect width='24' height='24' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}

export default GridIcon;
